import { useState, useEffect } from "react";
import { Link } from "react-scroll";
import {
  Navbar as NextNavbar,
  NavbarBrand,
  NavbarContent,
  NavbarItem,
  NavbarMenuToggle,
  NavbarMenu,
  NavbarMenuItem,
  Button,
} from "@nextui-org/react";
import { motion } from "framer-motion";
import ThemeToggle from "../../components/ThemeToggle";

const navItems = [
  { label: "Home", to: "heroSection" },
  { label: "Portfolio", to: "MyPortfolio" },
  { label: "Skills", to: "mySkills" },
  { label: "Certificates", to: "Certificates" },
  { label: "About", to: "AboutMe" },
];

export default function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <NextNavbar
      isBlurred
      isBordered
      isMenuOpen={isMenuOpen}
      onMenuOpenChange={setIsMenuOpen}
      maxWidth="xl"
      className={`fixed top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-white/80 dark:bg-black/80 backdrop-blur-xl border-b border-black/10 dark:border-white/10"
          : "bg-transparent border-transparent"
      }`}
      classNames={{
        wrapper: "px-4 md:px-8",
      }}
    >
      <NavbarBrand>
        <span className="font-display text-xl font-bold text-black dark:text-white tracking-tight">
          Angelo<span className="text-black dark:text-white">.</span>
        </span>
      </NavbarBrand>

      <NavbarContent className="hidden md:flex gap-8" justify="center">
        {navItems.map((item) => (
          <NavbarItem key={item.to}>
            <Link
              to={item.to}
              spy={true}
              smooth={true}
              offset={-80}
              duration={500}
              activeClass="!text-black dark:!text-white font-semibold"
              className="font-body text-sm font-medium text-black/60 hover:text-black
                         dark:text-white/60 dark:hover:text-white cursor-pointer transition-colors duration-200"
            >
              {item.label}
            </Link>
          </NavbarItem>
        ))}
      </NavbarContent>

      <NavbarContent justify="end">
        <NavbarItem className="hidden md:flex">
          <ThemeToggle />
        </NavbarItem>
        <NavbarItem>
          <Button
            as={Link}
            to="Contact"
            spy={true}
            smooth={true}
            offset={-60}
            duration={500}
            size="sm"
            className="font-body font-semibold bg-black text-white dark:bg-white dark:text-black
                       px-5 py-2 rounded-xl hover:bg-black/90 dark:hover:bg-white/90
                       transition-all duration-200 cursor-pointer"
          >
            Contact Me
          </Button>
        </NavbarItem>
        <NavbarMenuToggle className="md:hidden" />
      </NavbarContent>

      <NavbarMenu className="bg-white/95 dark:bg-black/95 backdrop-blur-xl pt-6">
        <div className="px-4 mb-6">
          <ThemeToggle />
        </div>
        {navItems.map((item, index) => (
          <NavbarMenuItem key={item.to}>
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: index * 0.1 }}
            >
              <Link
                to={item.to}
                spy={true}
                smooth={true}
                offset={-80}
                duration={500}
                onClick={() => setIsMenuOpen(false)}
                className="font-display text-2xl font-bold text-black/70 hover:text-black
                           dark:text-white/70 dark:hover:text-white cursor-pointer transition-colors py-2 block"
              >
                {item.label}
              </Link>
            </motion.div>
          </NavbarMenuItem>
        ))}
      </NavbarMenu>
    </NextNavbar>
  );
}
